module.exports = __webpack_public_path__ + "static/media/before_wanko.2dd7142d.jpeg";